import companyLogo from 'assets/funnel/power_serv.jpg';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import lackiererLandingHero from 'assets/funnel/lackier_start.png';
import lackiererHero from 'assets/funnel/lackier_main.png';
import lackiererGroup from 'assets/funnel/lackier_group.png';
import lackiererJobDetails from 'assets/funnel/lackier_job_details.png';

import lager_822_hero from 'assets/funnel/lager_822_hero.png';
import lager_822_info_1 from 'assets/funnel/lager_822_info_1.png';
import lager_822_info_2 from 'assets/funnel/lager_822_info_2.png';
import lager_822_info_3 from 'assets/funnel/lager_822_info_3.png';

const FUNNEL_CONFIGS = {
  lager_822: {
    documentTitle: "Lagerarbeiter (m/w/d) für Kommissioniertätigkeiten | POWERSERV Austria GmbH",
    companyLogo,
    companyName: "POWERSERV Austria GmbH",
    aiDisclaimer,

    landing: {
      heroImg: lager_822_hero,
      chipText: "Kein Staplerschein erforderlich.",
      heroTitle: "Lagerarbeiter (m/w/d) · Vollzeit",
      heroSubtitle: "Durchführen von Kommissioniertätigkeiten in Tirol / Rietz – starte jetzt durch.",
      facts: [
        { icon: 'bi-cash-stack',    title: '€ 2.304,60',             subtitle: 'Brutto-Mindestlohn / Monat · Vollzeit' },
        { icon: 'bi-geo-alt-fill',  title: 'Tirol / Rietz',          subtitle: 'Standort Österreich' },
        { icon: 'bi-shield-check',  title: 'Kein Staplerschein',      subtitle: 'erforderlich' },
        { icon: 'bi-apple',         title: 'Gratis Verpflegung',      subtitle: 'Obst, Gemüse, Kaffee & Tee' },
      ],
    },

    info: {
      heroImg: lager_822_info_1,
      heroChip: "Vollzeit · Lager & Kommissionierung",
      heroTitleLines: ["Lagerarbeiter", "(m/w/d)"],
      facts: [
        { value: "€ 2.304", label: "Brutto-Mindestlohn + Überzahlung möglich" },
        { value: "Vollzeit", label: "Tirol / Rietz" },
      ],
      moechtestDuItems: [
        { icon: 'bi-box-seam',   text: 'Kommissioniertätigkeiten im Trocken-, Kühl- und Tiefkühlbereich übernehmen?' },
        { icon: 'bi-headset',    text: 'mit modernsten sprachgesteuerten Systemen arbeiten und Waren für Filialbelieferungen zusammenstellen?' },
        { icon: 'bi-bicycle',    text: 'von Vorteilen wie E-Bike-Leasing, DU-Kultur und der Möglichkeit eines mehrmonatigen Sabbaticals profitieren?' },
      ],
      benefits: [
        { icon: 'bi-cash-stack',  title: '€ 2.304,60 Mindestlohn',  desc: 'Brutto pro Monat auf Basis Vollzeitbeschäftigung – bei entsprechender Qualifikation oder Erfahrung ist eine Überzahlung möglich.' },
        { icon: 'bi-moon-stars',  title: 'Nachtzulage',             desc: 'Gegebenenfalls Nachtzulage.' },
        { icon: 'bi-book',        title: 'Umfangreiche Einarbeitung', desc: 'Umfangreiche Einarbeitung inklusive.' },
        { icon: 'bi-apple',       title: 'Kostenlose Verpflegung',  desc: 'Täglich frisches Obst und Gemüse, Kaffee sowie Tee – kostenlos.' },
        { icon: 'bi-bicycle',     title: 'Fahrrad- & E-Bike-Leasing', desc: 'Leasingprogramm für Fahrräder und E-Bikes.' },
        { icon: 'bi-luggage',     title: 'Sabbatical möglich',      desc: 'Möglichkeit von mehrmonatigen Sabbaticals.' },
      ],
      tasks: [
        'Durchführen von Kommissioniertätigkeiten im Trocken-, Kühl- und Tiefkühlbereich',
        'Zusammenstellen von Waren für die Filialbelieferungen mit modernsten sprachgesteuerten Systemen',
        'Transportieren der Artikel innerhalb des Lagerbereichs mit elektrisch betriebenen Flurförderfahrzeugen',
        'Händisches Beladen der zu kommissionierenden Paletten',
        'Aktives Unterstützen bei unterschiedlichen Lagertätigkeiten',
      ],
      requirements: [
        'Grundlegende Deutsch- oder Englischkenntnisse',
        'Kein Staplerschein erforderlich',
        'Zuverlässige und selbstständige Arbeitsweise',
        'Bereitschaft zu körperlich anspruchsvollen Tätigkeiten',
        'Teamfähigkeit und Belastbarkeit',
      ],
      jobDetailsImg: lager_822_info_2,
      jobDetailsTagLines: ["Modernes Lager", "in Tirol"],
      noteText: "Aktives Unterstützen bei unterschiedlichen Lagertätigkeiten – mit modernster Technik und umfangreicher Einarbeitung.",
      groupImg: lager_822_info_3,
      companyDescription: "Wir bei POWERSERV Austria stellen Menschen in den Mittelpunkt – Bewerber:innen, Mitarbeiter:innen und Kund:innen. Unser Anspruch ist es, durch Qualität, persönliche Betreuung und Engagement die besten Lösungen in der Personaldienstleistung zu bieten. Als zugelassene Personalvermittlerin setzen wir auf nachhaltiges Wachstum, langjährige Partnerschaften und entwickeln uns laufend im Einklang mit den Markttrends weiter. Unsere Vision: arbeitssuchenden Menschen die passenden Karrieremöglichkeiten eröffnen und Unternehmen mit den richtigen Mitarbeiter:innen zusammenbringen.",
      finalCtaTitle: "Dann bist du bei uns genau richtig!",
      finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
    },

    quiz: {
      handshakeImg,
    },
  },
  lackierer: {
    documentTitle: "Lackierer:in (m/w/d) | POWERSERV Austria GmbH",
    companyLogo,
    companyName: "POWERSERV Austria GmbH",
    aiDisclaimer,

    landing: {
      heroImg: lackiererLandingHero,
      chipText: "Farbe bekennen.",
      heroTitle: "Lackierer:in (m/w/d) · Vollzeit",
      heroSubtitle: "Wir suchen dich! Verstärke das Team unseres Kunden in der Schienenfahrzeugtechnik.",
      facts: [
        { icon: 'bi-clock',         title: '38,5 Std. / Woche',       subtitle: '2-Schichtbetrieb 06:00 – 22:00 Uhr' },
        { icon: 'bi-cash-stack',    title: '€ 3.058,– + Überstunden', subtitle: 'voll ausbezahlt – kein Zeitausgleich' },
        { icon: 'bi-calendar-check',title: 'Start: ehestmöglich',     subtitle: 'langfristiger Einsatz' },
        { icon: 'bi-geo-alt-fill',  title: '1110 Wien',               subtitle: 'Öffentlich erreichbar' },
      ],
    },

    info: {
      heroImg: lackiererHero,
      heroChip: "Vollzeit · Schienenfahrzeugtechnik",
      heroTitleLines: ["Lackierer:in", "(m/w/d)"],
      facts: [
        { value: "€ 3.058", label: "Monatslohn + Überstunden" },
        { value: "38,5 h",  label: "geregelte Woche" },
      ],
      moechtestDuItems: [
        { icon: 'bi-brush',       text: 'dein Handwerk als Lackierer:in in einem international erfolgreichen Unternehmen der Schienenfahrzeugtechnik einsetzen?' },
        { icon: 'bi-train-front', text: 'an beeindruckenden Projekten arbeiten und Züge sowie Waggone mit hochwertigen Mehrschichtlackierungen veredeln?' },
        { icon: 'bi-award',       text: 'langfristig in einem stabilen Betrieb mit echter Übernahmemöglichkeit durch unseren Kunden tätig sein?' },
      ],
      benefits: [
        { icon: 'bi-clock',        title: '38,5-Stunden-Woche',    desc: 'Geregelter 2-Schichtbetrieb zwischen 06:00 und 22:00 Uhr.' },
        { icon: 'bi-cash-stack',   title: '€ 3.058,– Monatslohn',  desc: 'Überstunden werden vollständig ausbezahlt – kein Zeitausgleichskonto.' },
        { icon: 'bi-person-check', title: 'Echte Übernahmechance', desc: 'Langfristige Perspektive mit Übernahmemöglichkeit durch unseren Kunden.' },
        { icon: 'bi-layers',       title: 'Abwechslungsreiche Arbeit', desc: 'Von Schleifen und Kitten bis zur 7-Schicht-Lackierung – kein Tag wie der andere.' },
        { icon: 'bi-geo-alt-fill', title: '1110 Wien',             desc: 'Öffentlich erreichbar.' },
        { icon: 'bi-building',     title: 'Internationaler Betrieb', desc: 'Führender Anbieter für Instandhaltung und Weiterentwicklung von Schienenfahrzeugen.' },
      ],
      tasks: [
        'Lackieren von Zügen und Waggonen',
        'Schleifen und Kitten von Zugoberflächen',
        'Arbeiten mit Lackpistolen',
        'Mehrschichtlackierung (7 Schichten)',
      ],
      requirements: [
        'Abgeschlossene Berufsausbildung mit LAP als Lackierer oder Karosseriebautechniker (m/w/d)',
        'Mindestens 2 Jahre Berufserfahrung als Lackierer',
        'Deutschkenntnisse mindestens B2',
        'Selbstständige Arbeitsweise',
        'Teamfähigkeit und Verlässlichkeit',
        'Einwandfreier Leumund',
        'Überstundenbereitschaft auch am Samstag',
        'Bereitschaft für 2-Schichtbetrieb (06:00 – 22:00 Uhr)',
      ],
      jobDetailsImg: lackiererJobDetails,
      jobDetailsTagLines: ["Präzision in", "7 Schichten"],
      noteText: "Eine spannende, herausfordernde und abwechslungsreiche Position – jeder Waggon ist ein sichtbares Ergebnis deiner Arbeit.",
      groupImg: lackiererGroup,
      companyDescription: "Wir bei POWERSERV Austria stellen Menschen in den Mittelpunkt – Bewerber:innen, Mitarbeiter:innen und Kund:innen. Unser Anspruch ist es, durch Qualität, persönliche Betreuung und Engagement die besten Lösungen in der Personaldienstleistung zu bieten. Als zugelassene Personalvermittlerin setzen wir auf nachhaltiges Wachstum, langjährige Partnerschaften und entwickeln uns laufend im Einklang mit den Markttrends weiter. Unsere Vision: arbeitssuchenden Menschen die passenden Karrieremöglichkeiten eröffnen und Unternehmen mit den richtigen Mitarbeiter:innen zusammenbringen.",
      finalCtaTitle: "Dann bist du bei uns genau richtig!",
      finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
    },

    quiz: {
      handshakeImg,
    },
  },
};

export const DEFAULT_FUNNEL_TYPE = 'lackierer';
export default FUNNEL_CONFIGS;
